import React, { useMemo } from 'react';
import { Box } from '@chakra-ui/react';

import DemoBusinessReviewModal from './DemoBusinessReviewModal';

const VARIANTS = {
  'where-they-are': {
    label: 'where-they-are',
    dataVariant: 'where-they-are',
  },
  'where-youll-take-them': {
    label: 'where-youll-take-them',
    dataVariant: 'where-youll-take-them',
  },
};

const AgencyHeroReviewModule = ({
  variant = 'where-they-are',
  presentation = 'hero',
}) => {
  const config = VARIANTS[variant] || VARIANTS['where-they-are'];
  const isEmbed = presentation === 'embed';

  return (
    <Box w="100%" data-testid={`agency-hero-live-module-${config.label}`}>
      <Box
        w="100%"
        maxW={
          isEmbed
            ? '100%'
            : { base: '100%', md: '100%', lg: '1280px', xl: '1440px', '2xl': '1600px' }
        }
        mx={isEmbed ? 0 : 'auto'}
      >
        <DemoBusinessReviewModal
          isOpen
          onClose={() => {}}
          presentation={presentation}
          dataVariant={config.dataVariant}
        />
      </Box>
    </Box>
  );
};

export default AgencyHeroReviewModule;
